import { Card } from "@/components/ui/Card"
import type { PushAction, PushProduct } from "../data"
import ActionsSection from "./ActionsSection"
import Graphs from "./Graphs"
import MentionedBy, { type Mention } from "./MentionedBy"
import Section from "./Section"
import WhereItSits from "./WhereItSits"

interface Props {
  product: PushProduct
  actions: PushAction[]
  mentionedBy: Mention[]
  onChange: (actions: PushAction[]) => void
}

// The product the room is talking about right now, large: where the stock
// sits, how it has been selling, and the actions decided now.
export default function ProductDetail({ product, actions, mentionedBy, onChange }: Props) {
  return (
    <Card>
      <div className="px-6 py-5">
        <h2 className="text-xl font-semibold">{product.name}</h2>
        <div className="mt-0.5 text-sm text-muted-foreground">{[product.code, product.sku, product.category].filter(Boolean).join(" · ")}</div>
      </div>

      <Section title="Where it sits">
        <WhereItSits product={product} />
      </Section>

      <Section title="Graphs">
        <Graphs product={product} />
        <MentionedBy mentions={mentionedBy} />
      </Section>

      <ActionsSection actions={actions} giftable={product.giftable} onChange={onChange} />
    </Card>
  )
}
